import { GET_HOME_DATA, GET_HOME_LOADING, GET_LANDING_PAGE_DATA, GET_LANDING_PAGE_LOADING } from './home.types';

const INITIAL_STATE = {
  payload: null,
  error: null,
  isLoading: false,
};

const homeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_HOME_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_HOME_DATA:
      return {
        ...state,
        payload: action.payload,
        error: action.error,
        isLoading: false,
      };
    case GET_LANDING_PAGE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_LANDING_PAGE_DATA:
      return {
        ...state,
        payload: action.payload,
        error: action.error,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default homeReducer;
